export default {
  fillInstallation({ commit }, installation) {
    commit("updateIsSameAddress", installation.isSameAddress)
    commit("updateCep", installation.cep)
    commit("updateAddress", installation.address)
    commit("updateNumber", installation.number)
    commit("updateNoNumber", installation.noNumber)
    commit("updateNeighborhood", installation.neighborhood)
    commit("updateCity", installation.city)
    commit("updateCityId", installation.cityId)
    commit("updateState", installation.state)
    commit("updateStateId", installation.stateId)
    commit(
      "updateSecondaryAddress",
      installation.secondaryAddress || { type: "", text: "", value: "" }
    )
  }
}
